'use client';

import { useConsent } from '@/providers/consent-context';
import { measureOpenAiAdsEvent, OPENAI_ADS_PIXEL_ID } from '@/lib/analytics/openai-ads-pixel';

export default function useOpenAiAdsPixel() {
    const { canUseIntegration } = useConsent();

    const canTrack = !!OPENAI_ADS_PIXEL_ID && canUseIntegration('openaiAdsPixel');

    // Csak registration_completed / lead_created, minimális adattal (lásd lib/analytics/openai-ads-pixel.js)
    const measure = (eventName) => {
        if (!canTrack) return false;
        return measureOpenAiAdsEvent(eventName);
    };

    return {
        canTrack,
        measure
    };
}
